<template>
	<div class="c-generations-list">
		<div class="c-generations-list__loader" v-if="processing">
			<div class="c-spinner"></div>
		</div>
		<Item v-for="gen in computedGenerations" :key="gen.id" :generation="gen">
		</Item>
		<div class="c-generations-list__empty-state" v-if="empty">
			<strong> Nothing to show here. </strong>
			<p>All your AI generations(scripts, concepts, etc) will show up here.</p>
			<router-link to="/script" class="btn btn-primary">
				Create AI script
			</router-link>
		</div>
		<button
			:class="['btn btn-box', { 'btn-primary': processing === true }]"
			@click="loadMore"
			v-if="!max && !processing && !empty"
		>
			<span class="c-spinner" v-if="processing"></span>
			<span> Load more </span>
		</button>
	</div>
</template>

<script>
import Item from './item.vue';

export default {
	components: {
		Item,
	},

	data: function () {
		return {
			params: {
				skip: 0,
			},

			processing: false,

			max: false,
		};
	},

	computed: {
		empty: function () {
			if (this.processing) {
				return false;
			}
			if (this.generations.length === 0) {
				return true;
			}
		},
		generations: function () {
			return this.$store.getters['briefs/generations'];
		},
		computedGenerations: function () {
			let generations = this.generations;

			for (let i = 0; i < generations.length; i++) {
				let gen = generations[i];
				//gen.status = 'FAILED';

				generations[i] = gen;
			}

			return generations;
		},
	},

	methods: {
		async load() {
			this.processing = true;

			const generations = await this.$store.dispatch(
				'briefs/refreshGenerations',
				this.params
			);

			if (generations.length < 50) {
				this.max = true;
			}

			this.processing = false;
		},
		async loadMore() {
			this.processing = true;

			this.params.skip += 1;

			const generations = await this.$store.dispatch(
				'briefs/loadMoreGenerations',
				this.params
			);

			if (generations.length < 50) {
				this.max = true;
			}

			this.processing = false;
		},
	},

	mounted: function () {
		this.load();
	},
};
</script>

<style lang="scss">
.c-generations-list {
	max-width: 680px;
	margin: 0 auto;
	padding-top: 2rem;
	padding-bottom: 2rem;

	&__empty-state {
		text-align: center;

		strong {
			display: block;
			font-weight: 500;
			margin-bottom: 0.5rem;
		}
	}

	> .btn {
		width: 100%;
	}

	&__loader {
		display: flex;
		justify-content: center;
		margin-bottom: 1rem;

		> .c-spinner {
			border-color: var(--color-primary);
			border-bottom-color: transparent;
		}
	}
}
</style>
